module.exports = __webpack_public_path__ + "static/media/logo.44fad071.svg";